/* Action types with TypeScript type declaration */
export const SEARCH = 'rpb2b-react/search/Search';
export type SEARCH = typeof SEARCH;

export const SEARCH_PAGE = 'rpb2b-react/search/SearchPage';
export type SEARCH_PAGE = typeof SEARCH_PAGE;

export const SEARCH_TEXT = 'rpb2b-react/search/SearchText';
export type SEARCH_TEXT = typeof SEARCH_TEXT;

export const SEARCH_RESULTS = 'rpb2b-react/search/SearchResults';
export type SEARCH_RESULTS = typeof SEARCH_RESULTS;

export const SEARCH_LOADING = 'rpb2b-react/search/SearchLoading';
export type SEARCH_LOADING = typeof SEARCH_LOADING;

export const SEARCH_PENDING = 'rpb2b-react/search/SearchPending';
export type SEARCH_PENDING = typeof SEARCH_PENDING;

export const SEARCH_SUCCESS = 'rpb2b-react/search/SearchSuccess';
export type SEARCH_SUCCESS = typeof SEARCH_SUCCESS;

export const SEARCH_ERROR = 'rpb2b-react/search/SearchError';
export type SEARCH_ERROR = typeof SEARCH_ERROR;

export default {
  SEARCH,
  SEARCH_PAGE,
  SEARCH_TEXT,
  SEARCH_RESULTS,
  SEARCH_LOADING,
  SEARCH_ERROR
};
